var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoInfoCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#1C2743",
    d: "m10,20c5.5228,0 10,-4.4772 10,-10c0,-5.52285 -4.4772,-10 -10,-10c-5.52285,0 -10,4.47715 -10,10c0,5.5228 4.47715,10 10,10zm1.1634,-11.76514l-1.2525,5.88134c-0.0879,0.4248 0.0367,0.6665 0.3809,0.6665c0.2417,0 0.6079,-0.0879 0.8569,-0.3076l-0.1098,0.52c-0.3589,0.4321 -1.1499,0.7471 -1.83109,0.7471c-0.8789,0 -1.25244,-0.5274 -1.01074,-1.648l0.92285,-4.3359c0.08057,-0.36621 0.00733,-0.49805 -0.35889,-0.58594l-0.56396,-0.10254l0.10254,-0.47607l2.86379,-0.35889zm-1.1634,-1.35986c-0.69036,0 -1.25,-0.55964 -1.25,-1.25c0,-0.69036 0.55964,-1.25 1.25,-1.25c0.6904,0 1.25,0.55964 1.25,1.25c0,0.69036 -0.5596,1.25 -1.25,1.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInfoCircleFill);
export default __webpack_public_path__ + "static/media/ico-info-circle-fill.7fdcb8d0b6ab56c153c0ebded509dc06.svg";
export { ForwardRef as ReactComponent };